module.exports = __webpack_public_path__ + "img/hamburg.4654db12.jpg";